import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {PricingModelType} from './constants'

const initialState = {
    firstLoading: true,
    loading: false,
    pricingModelType: PricingModelType.USER,
    licenses: [],
    currentUsedUser: 0,
    licensedTo: {},
    paymentMethod: null,
    cardInfo: {},
    havePurchases: false,
    documentsBaseUrl: '',
    countries: [],
    statesByCountry: {},
    maxUsersToUnlimited: 1,
    maxFreeUsers: 0,
    unavailableInFreeFeatures: [],
    minWireTransferAmount: 0,
}

export default handleActions({
    [ActionTypes.LOAD_DATA]: (state) => ({
        ...state,
        loading: true,
    }),
    [ActionTypes.LOAD_DATA_SUCCESS]: (state) => ({
        ...state,
        firstLoading: false,
        loading: false,
    }),
    [ActionTypes.LOADED_DATA_SET]: (state, {payload: loadedData}) => ({
        ...state,
        pricingModelType: loadedData.pricingModelType,
        licenses: loadedData.licenses,
        maxUsersToUnlimited: loadedData.unlimitedFrom,
        maxFreeUsers: loadedData.freeUsersMax,
        unavailableInFreeFeatures: loadedData.unavailableInFreeFeatures,
        licensedTo: loadedData.companyInfo,
        paymentMethod: loadedData.paymentMethod,
        cardInfo: loadedData.creditCard,
        havePurchases: loadedData.havePurchases,
        minWireTransferAmount: loadedData.minWireTransferAmount,
        currentUsedUser: loadedData.currentUsedUserCount,
        documentsBaseUrl: loadedData.documentsBaseUrl,
        countries: loadedData.countries,
        statesByCountry: loadedData.statesByCountry,
        usersLowerLimit: loadedData.usersLowerLimit,
    }),
    [ActionTypes.LOAD_DATA_FAILURE]: (state) => ({
        ...state,
        firstLoading: false,
    }),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/reducer.js